import { useState, useEffect, useRef, useCallback } from 'react';
import { isValidFuntion,getTodayDateYYMMDD } from '../../control/Constant';
import { Services } from "../../network/Services";

const SearchBar = ({showDropdown, setShowDropdown, setMatterNumber,matterNumber,results,setSearchData,runApis,reference,pageName,setuseLoader,subtinentId,triggerUpdateApi,setTriggerUpdateApi}) => {
const debounceTimeout = useRef(null);
const skipNextDebounce = useRef(false); // ← NEW flag
 let isOtpVarified = JSON.parse(sessionStorage.getItem('isOtpVarified'));
 const [searchedData,setSearchedData]=useState()


const handleChangeInput = useCallback((data,key) => {
    setMatterNumber(data);
    if (key === 'Enter') {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    runApis(data);
    return;
  }
  if(debounceTimeout.current){
    clearTimeout(debounceTimeout.current);
  }
  

  debounceTimeout.current = setTimeout(() => {
    setTimeoutFunc(data); // Pass the latest value
  }, 1000);
}, [runApis, setMatterNumber]);

const setTimeoutFunc = (value) => {
  setTimeout(() => {
    runApis(value); // Use the passed value
  }, 1000);
};

useEffect(()=>{
  if(pageName=="refundSearchBar" && triggerUpdateApi==true){
    onClicksearchedDataFun(searchedData)
  }
},[triggerUpdateApi])



  async function onClicksearchedDataFun(item){
    let itemDetails=item;
    setSearchedData(itemDetails)
    // console.log("ervdscx",itemDetails)
    if(pageName=="refundSearchBar"){
        // Skip GetClientARDetailsByUserId API for Federal Way Plaza (989, 760)
        if(subtinentId == 989 || subtinentId == 760) {
          // For Federal Way Plaza, use the item data directly without additional API call
          setSearchData(itemDetails);
          setMatterNumber("");
          setTriggerUpdateApi(false);
          return;
        }
        
        setuseLoader(true)
        const inputData={
            pageNumber:1,
            rowsOfPage:40,
            subtenantId:subtinentId,
            isTimeMatterClient:null
          }
        
        const _resultOf = await Services.GetClientARDetailsByUserId(inputData,itemDetails?.memberId);
        try{
            let resData = _resultOf?.data?.data[0];
            if(resData?.clientAuthSubsVMs?.length>0){
              let newData=resData?.clientAuthSubsVMs?.map((value1)=>{
                if(value1?.clientAuthSchVMs?.length>0){
                      const updatesSub_withDate=value1?.clientAuthSchVMs?.filter((value2)=>{
                      const todaysDate=getTodayDateYYMMDD()
                      const installmentDateGet= value2?.installmentDate.split("T")[0];
                      const checkIf_Past_OrCurDate=installmentDateGet>todaysDate
                      return installmentDateGet>todaysDate && (value1?.authSubscriptionId!= null && value1?.authSubscriptionId!= "" && value1?.isCancelSubscription!=true)
                    })
                    return {...value1,clientAuthSchVMs:updatesSub_withDate}
                }
                return value1
              })

              resData={...resData,clientAuthSubsVMs:newData}
            }
            itemDetails=resData || {}
          setuseLoader(false)
        }catch(err){
          setuseLoader(false)
        }
        setTriggerUpdateApi(false)
     
    }
    setSearchData(itemDetails);
    setMatterNumber("");
   
    if (typeof window.setEditClickGlobal === "function") {
      window.setEditClickGlobal(false);
    }
  }


  return (<>
    <div className={`relative ${reference == 'Agingoption' ? "mx-6" : ""}`}>
    {reference == 'FederalWay' ? <label className="block text-sm font-medium text-gray-700 mb-1">Tenant Name / Unit Number*</label> :<h3 className={`text-lg font-semibold mb-1 ${reference == 'FederalWay' ? 'text-sm' : reference == 'Agingoption' ? 'font-semibold' : 'text-sm'}`}>
      {reference == 'FederalWay' ? 'Tenant Name / Unit Number' :reference == 'Agingoption' ? 'Search by Email and Name' : pageName == 'refundSearchBar' && (subtinentId == 3 || subtinentId == '3') ? 'Name / Email' : 'Matter Number / Name / Email'}
    </h3>}
    <div className="flex gap-2">
      <input
        type="search"
        placeholder={reference == 'FederalWay' ? 'Enter tenant name or unit number' :reference == 'Agingoption' ? 'Enter the email address' : pageName == 'refundSearchBar' && (subtinentId == 3 || subtinentId == '3') ? "Enter by name or email" : "Enter by matter number, name or email"}
        className="w-full px-3 py-2 border border-gray-300 rounded-md"
        value={matterNumber}
        onChange={(e) => handleChangeInput(e.target.value,e.key)}
        onKeyDown={(e) => handleChangeInput(e.target.value,e.key)}
      />
   </div>
    {showDropdown && (matterNumber || isOtpVarified) && results?.length > 0 && (
      <ul className="absolute top-full left-0 mt-1 w-full sm:w-85 md:w-85 lg:w-96 bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-lg" style={{zIndex:10000}}>
        {isValidFuntion(results) && results?.length > 0 && results?.map((item, index) => (
          <li
            key={index}
            className="px-4 py-1 hover:bg-blue-100 cursor-pointer"
            onClick={()=>(onClicksearchedDataFun(item))}
          >
            {reference == 'FederalWay' ? <>
                <span className="font-semibold text-sm block leading-tight">
                  {item.tenantName || item.memberName}
                </span>
                <span className="text-xs block leading-tight text-gray-700">
                  Unit no: {item?.unitNumber || item?.matNo}
                </span>
              </> : reference === 'Agingoption' ? <>
                <span className="font-semibold text-sm block leading-tight">
                  {item.fullName}
                </span>
                <span className="text-xs block leading-tight text-gray-700">
                  Email: {item?.primaryEmail}
                </span>
              </> : (<>
                <span className="font-semibold text-sm block leading-tight">
                  {item.memberName}
                </span>
                <span className="text-xs block leading-tight text-gray-700">
                  Mat No: {item?.matNo}
                </span>
                <span className="text-xs block leading-tight text-gray-700">
                  Email: {item?.primaryEmailAddress}
                </span>
              </>
            )}
          </li>
        ))}
      </ul>
    )}
  </div>
  </>)
}

export default SearchBar